module.exports = __webpack_public_path__ + "img/75.15b9a9b0.jpg";